import React, { useState, useEffect, useRef } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import ListingComponent from '../../components/ListingComponent';
import { useParams } from  'react-router-dom'
import UI_ACTIONS from '../../data/UiActionConstants';
import UiAction from '../../components/UiAction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Multiselect from 'multiselect-react-dropdown';
import { resetQueryParams } from "../../ui/customerListingReducer.js";
import { useSelector, useDispatch } from "react-redux";
// import { useParams, useNavigate } from "react-router-dom";
// import { getApi } from "../../api/endpoints";

const Listing = (props) => {
  const defaultHeaderConfig = { disableSort: true };
  const navigate = useNavigate();
  const params = useParams();
  const [updateApi] = getApi('updateUser');
  const [fetchZoneApi] = getApi('zones');
  const [zone, setZone] = useState(null);
  const [zones, setZones] = useState([]);
  const dispatch = useDispatch();
  const zoneRef = useRef();

  useEffect(()=>{
    fetchZones();
  }, [])

  const onZoneSelect = (_, selectedItem) => {
    setZone(selectedItem.id)
  }

  const handleZoneMap = async () => {
    if(zone == null) {
      toast.error("Please select zone.")
      return
    }
    try {
      let parameter = {
        id: params.id,
        user: {
          zone_user_mappings_attributes: [{zone_id: zone, user_id: params.id, company_id: 2, is_valid: true}]
        }
      }
      await updateApi(parameter).unwrap();
      window.location.reload();
      // dispatch(resetQueryParams())
    } catch {
      toast.error("Something went wrong.")
    }
  }

  const fetchZones = async () => {
    try {
      let response = await fetchZoneApi(params).unwrap();
      setZones(response.data.zones)
    } catch {
      toast.error("Zones not found")
    }
  }

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Zone',
      value: (row) => row.zone.name,
    },
    {
      ...defaultHeaderConfig,
      label: 'Valid',
      value: (row) => row.is_valid ? "True" : "False",
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at'
    },
  ]

  return <>
  <div className="row">
    <div className="col-md-2 mx-2">
      <label htmlFor="zones" className='form-label'>Select Zones</label>
      <Multiselect
       id="zones"
       options={zones}
       selectedValues={props.zones}
       onSelect={onZoneSelect}
       placeholder='Select from options'
       displayValue={'name'}
       showArrow={true}
       customArrow={true}
       singleSelect={true}
       avoidHighlightFirstOption={true}
       disablePreSelectedValues={true}
       ref={zoneRef}
     />
   </div>
    <div className="col-md-2 my-3">
      <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleZoneMap}> Map Zone </button>
    </div>
 </div>
  <ListingComponent
    key={"PAGES.WorkOrdersListingPage.name"}
    listingMutation={getApi('zoneUserMappings')}
    contentHeading="Zone-User Mappings"
    headers={headers}
    params={{id: params.id}}
    recordsKey="zone_user_mappings"
    hideSearch={true}
  /></>
};

export default Listing;
